import { FormControl, InputLabel, InputLabelProps, makeStyles, MenuItem, Select, SelectProps } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles(theme => ({
  emptySelect: {
    color: theme.palette.text.disabled,
  },
}));

interface SelectWithErrorFieldProps extends SelectProps {
  disabled?: boolean;
  error: boolean;
  errorMessage: string | undefined;
  selectLabel?: string;
  choices: Array<any> | null | undefined;
  choiceDisplayKey: string;
  choiceValueKey?: string;
  InputLabelProps?: InputLabelProps;
  variant?: 'standard' | 'outlined' | 'filled';
  placeholder?: string;
  classNameForSelect?: string;
}

const SelectWithErrorField: React.FC<SelectWithErrorFieldProps> = props => {
  const {
    id,
    className,
    classNameForSelect = '',
    choices,
    selectLabel,
    choiceDisplayKey,
    choiceValueKey = '@id',
    errorMessage,
    error,
    InputLabelProps,
    variant = 'outlined',
    placeholder,
    ...selectProps
  } = props;
  const classes = useStyles();

  return (
    <FormControl variant={variant} error={error} disabled={props.disabled} className={className}>
      {selectLabel && (
        <InputLabel id={`${id}-label`} {...InputLabelProps}>
          {selectLabel}
        </InputLabel>
      )}
      <Select
        IconComponent={ExpandMoreIcon}
        labelId={`${id}-label`}
        id={id}
        displayEmpty
        className={classNames({
          [classes.emptySelect]: '' === selectProps.value,
          [classNameForSelect]: '' !== classNameForSelect,
        })}
        {...selectProps}
      >
        <MenuItem value="" disabled={!!placeholder}>
          {placeholder ?? ''}
        </MenuItem>
        {choices &&
          choices.map(choice => (
            <MenuItem key={choice[choiceValueKey]} value={choice[choiceValueKey]}>
              {choice[choiceDisplayKey]}
            </MenuItem>
          ))}
      </Select>
      {error && <FormHelperText error>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default SelectWithErrorField;
